import { useCallback } from 'react';
import CmdItem from '../cmdkItem';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { IconDiv } from '../vercelstyle';
import { ICON_SIZE } from '../../../global/constants';

function RecordItem({
  setInputValue,
  closePopup,
  openSnapModal,
  storeRecentSearch
}: {
  setInputValue: Function;
  closePopup?: Function;
  openSnapModal: Function;
  storeRecentSearch: Function;
}) {
  const onRecordSnap = useCallback(() => {
    storeRecentSearch('Record Snap', 8, '');
    openSnapModal();
    setInputValue('');
    closePopup?.();
  }, [closePopup, openSnapModal, setInputValue, storeRecentSearch]);

  return (
    <>
      <CmdItem
        onSelect={() => {
          onRecordSnap();
        }}>
        <IconDiv>
          <SVGIcon
            name='record-snap-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-secondary)'
            className='record-snap-icon'
          />
        </IconDiv>
        Record Snap
      </CmdItem>
    </>
  );
}

export default RecordItem;
